// extracted by mini-css-extract-plugin
export default {"container":"EventTitleInput_container__hSAOJ","deleteButton":"EventTitleInput_deleteButton__z3Dqr"};